module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Bar.js"));
	}, "Bar");
}